module.exports = __webpack_public_path__ + "static/media/SDFSA_5-845w.3a48d47f.jpg";